import type { CuratedItem, Image } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryListPaginationIntegrityProps {
    items?: CuratedItem[];
    image?: Image;
    embedUrl?: string;
    liveStream?: string;
}

export default function integrityCheck({
    items = [],
}: StoryListPaginationIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
